<div class="name-mismatch-notice" role="alert">
  <ac-icon iconKey="hr:warning" class="name-mismatch-notice__icon" />
  <div class="name-mismatch-notice__body">
    <span class="ac-body-sm">{{ message }}</span>
    <button type="button" class="ac-link name-mismatch-notice__support" (click)="contactSupport.emit()">
      Contact Support
    </button>
  </div>
</div>
